import { render, staticRenderFns } from "./DomainAnalysis.vue?vue&type=template&id=10721a8c&scoped=true&"
import script from "./DomainAnalysis.vue?vue&type=script&lang=js&"
export * from "./DomainAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./DomainAnalysis.vue?vue&type=style&index=0&id=10721a8c&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "10721a8c",
  null
  
)

export default component.exports